/* ==========================================================================
   Real Cute Gifts Co — theme.js
   Vanilla JS, no build step. Uses Shopify's Ajax Cart API.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  initCartDrawer();
  initAddToCartForms();
  initQtySteppers();
  initCharCounters();
  initMobileNav();
  initSearchToggle();
  refreshCartDrawer(); // populate on load
});

/* --------------------------------------------------------------------
   Cart drawer open/close
   -------------------------------------------------------------------- */
function initCartDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  if (!drawer || !overlay) return;

  const openers = document.querySelectorAll('[data-cart-open]');
  const closers = document.querySelectorAll('[data-cart-close]');

  openers.forEach((btn) =>
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
    })
  );

  closers.forEach((btn) =>
    btn.addEventListener('click', () => closeCartDrawer())
  );

  overlay.addEventListener('click', () => closeCartDrawer());

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCartDrawer();
  });
}

function closeCartDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  if (!drawer || !overlay) return;
  drawer.classList.remove('is-open');
  overlay.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
}

/* --------------------------------------------------------------------
   Add to cart (Ajax), works for the product form + quick-add cards
   -------------------------------------------------------------------- */
function initAddToCartForms() {
  document.querySelectorAll('form[data-product-form]').forEach((form) => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding…';
      }

      const formData = new FormData(form);

      fetch(window.Shopify ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status) {
            // Shopify returns an error object with a `status` key on failure
            showFormError(form, data.description || 'Could not add this item to your cart.');
            return;
          }
          refreshCartDrawer();
          openDrawerNow();
        })
        .catch(() => {
          showFormError(form, 'Something went wrong. Please try again.');
        })
        .finally(() => {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
        });
    });
  });
}

function showFormError(form, message) {
  let el = form.querySelector('[data-form-error]');
  if (!el) {
    el = document.createElement('p');
    el.setAttribute('data-form-error', '');
    el.className = 'field-hint';
    el.style.color = 'var(--color-rust)';
    form.appendChild(el);
  }
  el.textContent = message;
}

function openDrawerNow() {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  if (!drawer || !overlay) return;
  drawer.classList.add('is-open');
  overlay.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
}

function refreshCartDrawer() {
  const root = document.querySelector('[data-cart-drawer-items]');
  if (!root) return;

  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
      document.querySelectorAll('[data-cart-subtotal]').forEach((el) => {
        el.textContent = formatMoney(cart.total_price);
      });

      if (cart.item_count === 0) {
        root.innerHTML = '<p class="field-hint" style="padding:2rem 0;text-align:center;">Your bag is empty — time to find something special.</p>';
        return;
      }

      root.innerHTML = cart.items
        .map(
          (item) => `
        <div class="cart-line" data-line-key="${item.key}">
          <img src="${item.image}" alt="${escapeHtml(item.product_title)}" loading="lazy" width="72" height="72">
          <div style="flex:1;">
            <div class="cart-line__title">${escapeHtml(item.product_title)}</div>
            ${item.variant_title ? `<div class="field-hint">${escapeHtml(item.variant_title)}</div>` : ''}
            ${renderLineProperties(item.properties)}
            <div style="display:flex;align-items:center;justify-content:space-between;margin-top:0.5em;">
              <span class="field-hint">Qty ${item.quantity}</span>
              <span>${formatMoney(item.final_line_price)}</span>
            </div>
            <button type="button" class="btn--ghost" style="margin-top:0.5em;font-size:0.75rem;" data-remove-line="${item.key}">Remove</button>
          </div>
        </div>`
        )
        .join('');

      root.querySelectorAll('[data-remove-line]').forEach((btn) => {
        btn.addEventListener('click', () => removeCartLine(btn.getAttribute('data-remove-line')));
      });
    });
}

function renderLineProperties(properties) {
  if (!properties) return '';
  const entries = Object.entries(properties).filter(([k, v]) => v && !k.startsWith('_'));
  if (!entries.length) return '';
  return `<div class="field-hint">${entries.map(([k, v]) => `${escapeHtml(k)}: ${escapeHtml(v)}`).join(' · ')}</div>`;
}

function removeCartLine(key) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 }),
  })
    .then((res) => res.json())
    .then(() => refreshCartDrawer());
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

function escapeHtml(str) {
  const div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

/* --------------------------------------------------------------------
   Quantity steppers
   -------------------------------------------------------------------- */
function initQtySteppers() {
  document.querySelectorAll('[data-qty-stepper]').forEach((stepper) => {
    const input = stepper.querySelector('input');
    stepper.querySelectorAll('button').forEach((btn) => {
      btn.addEventListener('click', () => {
        const dir = btn.getAttribute('data-qty-dir');
        let val = parseInt(input.value, 10) || 1;
        val = dir === 'up' ? val + 1 : Math.max(1, val - 1);
        input.value = val;
        input.dispatchEvent(new Event('change'));
      });
    });
  });
}

/* --------------------------------------------------------------------
   Personalization textarea character counters
   -------------------------------------------------------------------- */
function initCharCounters() {
  document.querySelectorAll('[data-char-count-for]').forEach((counter) => {
    const targetId = counter.getAttribute('data-char-count-for');
    const target = document.getElementById(targetId);
    if (!target) return;
    const max = parseInt(target.getAttribute('maxlength'), 10) || 0;

    const update = () => {
      const len = target.value.length;
      counter.textContent = max ? `${len} / ${max}` : `${len}`;
      counter.classList.toggle('is-limit', max && len >= max);
    };
    target.addEventListener('input', update);
    update();
  });
}

/* --------------------------------------------------------------------
   Mobile nav
   -------------------------------------------------------------------- */
function initMobileNav() {
  const burger = document.querySelector('[data-nav-burger]');
  const panel = document.querySelector('[data-nav-mobile]');
  if (!burger || !panel) return;
  burger.addEventListener('click', () => {
    const open = panel.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
}

/* --------------------------------------------------------------------
   Header search toggle
   -------------------------------------------------------------------- */
function initSearchToggle() {
  const btn = document.querySelector('[data-search-open]');
  const panel = document.querySelector('[data-search-panel]');
  if (!btn || !panel) return;
  const input = panel.querySelector('[data-search-input]');
  const closeBtn = panel.querySelector('[data-search-close]');

  function openSearch() {
    panel.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    if (input) setTimeout(() => input.focus(), 50);
  }

  function closeSearch() {
    panel.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
  }

  btn.addEventListener('click', () => {
    if (panel.classList.contains('is-open')) {
      closeSearch();
    } else {
      openSearch();
    }
  });

  if (closeBtn) closeBtn.addEventListener('click', () => closeSearch());

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSearch();
  });
}
